module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACVSURBVDhPrdMxDoIwFIfx1zC6ODl04wy9mJ5Eb8EZXLhBdxbmxgM4OdT3KSEBSinGL/kvr8lvAuOcu4rIWfePblUI4W6tPcYYT8aYlx4P37finrpO13jvLxWXAa0VrXeiYL2uBePwAekHdIHRCNIONInRBKQCdBWjBUgZNItREqQESlmMVkGaoQ89ZbHi+PiHH2AjkTcazGzLtOYxbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjx.png
// module id = RCg2
// module chunks = 1